import { Box, Typography } from "@mui/material";
import { useBrandingStore } from "../../stores/Branding";
import { useEffect, useMemo } from "react";
import useRefresh from "../../hooks/useRefresh";

export default function TitleWithLogo() {
  const branding = useBrandingStore((s) => s.branding);

  const imageSrc = useMemo(() => {
    if (!branding.logo.image)
      return require("../../assets/logo-no-background.png");
    else return branding.logo.image;
  }, [branding.logo.image]);

  return (
    <Box display="flex" alignItems="center">
      <img
        src={imageSrc}
        style={{ height: 30, width: 30, marginRight: "1em" }}
      />
      <Typography fontWeight={500} fontSize={16}>
        {branding.shortname}
      </Typography>
    </Box>
  );
}
